import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { RootState } from 'reducers';
import { Button, Input, Select, DatePicker, Modal } from 'components';
import { Constants, Globals } from 'utils';
import { AdvertisementService, ProfileService, UserService } from 'services';
import { CloseIcon } from "assets/icons";

interface Props extends Pick<RootState, 'user'> {
  type: 'banner' | 'classified'
  paymentData: {
    payment_method_id?: string | number
    advertising_rate_id?: string | number
    days?: string | number
    image?: any
    classified_rate_id?: string | number
    title?: string
    content?: string
    document?: any
    amount: number
    seller_code?: string
  }
  visible: boolean
  onClose: () => void
  onSuccess: () => void
}

class AdPaymentModal extends React.Component<Props> {

  state = {
    payment_methods: [],
    banks: [],
    form: {
      advertising_rate_id: '',
      classified_rate_id: '',
      title: '',
      content: '',
      days: '',
      image: '',
      document: '',
      seller_code: '',

      user_id: this.props.user?.id,
      payment_method_id: '',
      currency: '',
      bank_id: '',
      payment_phonecode_id: '',
      payment_phone: '',
      payment_name: '',
      payment_email: '',
      payment_document: '',
      payment_date: '',
      reference: '',
      subtotal: 0,
      iva: 0,
      iva_percentage: 0,
      amount: 0,
      amount_bs: 0,
      conversion: 0,
      hasFile: true,
    },
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const selects: any = await UserService.admin.getSelects();
    const res: any = await ProfileService.getDocumentTypes({ user_id: this.props.user?.id });

    // Calcula el precio final
    const subtotal = Number(this.props.paymentData.amount);
    const iva = (subtotal * Number(selects?.iva?.percentage || 0)) / 100;
    const amount = subtotal + iva;
    const amount_bs = Number(parseFloat(String(amount * selects?.conversion)).toFixed(2));

    const localCurrencies = [Constants.PAYMENT_METHODS.MOVIL];

    this.setState((s : any) => ({
      banks: res.banks.map((i: any) => ({ value: i.id, label: i.name })),
      payment_methods: selects.paymentMethods, // Omite Efectivo
      form: {
        ...s.form,
        user_id: this.props.user?.id,
        payment_method_id: String(this.props.paymentData?.payment_method_id),
        currency: localCurrencies.includes(Number(this.props.paymentData?.payment_method_id)) ? 1 : 2,
        advertising_rate_id: this.props.paymentData.advertising_rate_id || '',
        classified_rate_id: this.props.paymentData.classified_rate_id || '',
        title: this.props.paymentData.title || '',
        content: this.props.paymentData.content || '',
        days: this.props.paymentData.days || '',
        image: this.props.paymentData.image?.value || '',
        document: this.props.paymentData.document?.value || '',
        seller_code: this.props.paymentData.seller_code || '',
        subtotal,
        iva,
        iva_percentage: selects.iva.percentage,
        amount,
        amount_bs,
        conversion: selects.conversion,
      }
    }));
  }

  change = (e: any, callback = () => {}) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value
      }
    },callback);
  }

  isValidForm = () => {
    const onError = (msg: string) => {
      Globals.showError(msg);
      return false;
    }

    const { form } = this.state;

    if (this.props.type === 'banner') {
      if (!form.advertising_rate_id)
        return onError('Debe seleccionar un banner');

      if (!form.days)
        return onError('Debe seleccionar un tiempo');

      if (!form.image)
        return onError('Debe subir una imagen');

    } else if (this.props.type === 'classified') {
      if (!form.classified_rate_id)
        return onError('Debe seleccionar un clasificado');

      if (!form.title)
        return onError('Debe ingresar un título');

      if (!form.content)
        return onError('Debe ingresar un contenido');

      if (!form.document)
        return onError('Debe seleccionar un documento');
    }

    if (+form.payment_method_id === Constants.PAYMENT_METHODS.ZELLE) {
      if (!form.payment_email.trim())
        return Globals.showError('Debe ingresar el correo emisor');

      if (!form.payment_name.trim())
        return Globals.showError('Debe ingresar el nombre del emisor');
    }

    if (+form.payment_method_id === Constants.PAYMENT_METHODS.MOVIL) {
      if (!form.payment_date)
        return Globals.showError('Debe ingresar la fecha de pago');

      if (!form.bank_id)
        return Globals.showError('Debe ingresar el banco emisor');

      if (!form.payment_phone.trim())
        return Globals.showError('Debe ingresar el teléfono emisor del pago');
    }

    if (!form.reference.trim())
      return onError('Debe ingresar la referencia del pago');

    return true;
  }

  submit = async (e: any) => {
    e.preventDefault();
    if (!this.isValidForm()) return;

    const { form } = this.state;
    const todayStr = new Date().toISOString().split('T')[0];
    const payload = {
      ...this.state.form,
      payment_document: form.payment_document.trim(),
      payment_date: todayStr,
      payment_name: form.payment_name.trim(),
      payment_email: form.payment_email.trim(),
      reference: form.reference.trim(),
    };

    try {
      await AdvertisementService.affiliate.payAd(payload);
      Globals.showSuccess('Su pago se realizó con éxito. Espere aprobación de la publicidad');
      this.props.onSuccess();

    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { form } = this.state;
    const payment_method: any = this.state.payment_methods.find((i: any) => i.id === +form.payment_method_id);

    return (
      <Modal
        className="modal-payment-ad"
        withoutClose
        visible={this.props.visible}
        onClose={() => this.props.onClose()}
      >
        <div className="container">
          <button className="close" onClick={() => this.props.onClose()}>
            <img src={CloseIcon} alt="Close" />
          </button>

          {
            this.props.paymentData.payment_method_id === Constants.PAYMENT_METHODS.ZELLE && (
              <React.Fragment>
                <p className="title">Zelle</p>

                <div className="row px-3">
                  <div>
                    <p className="label-payment">Datos para el pago</p>
                    <p className="data-payment"><span>Correo: </span>{ payment_method?.email }</p>
                  </div>
                  <div className="right">
                    <p className="label-payment">Monto a pagar</p>
                    <p className="label-amount">{ Globals.formatMiles(form.amount, true) }</p>
                    <p className="data-payment">Subtotal { Globals.formatMiles(form.subtotal, true) }</p>
                    <p className="data-payment">IVA ({ form.iva_percentage }%): { Globals.formatMiles(form.iva, true, 'Bs.') }</p>
                  </div>
                </div>

                <br />
                <p className="label-verify">Verificación de pago</p>
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      color="white"
                      value={ form.payment_email }
                      name="payment_email"
                      placeholder="Correo emisor"
                      onChange={ this.change } />
                  </div>
                  <div className="col-md-6">
                    <Input
                      color="white"
                      value={ form.payment_name }
                      name="payment_name"
                      placeholder="Nombre y apellido del titular"
                      onChange={ this.change } />
                  </div>
                  </div>
                  <div className="row">
                  <div className="col-md-12">
                    <Input
                      color="white"
                      value={ form.reference }
                      name="reference"
                      placeholder="Referencia"
                      onChange={ this.change } />
                  </div>
                </div>
              </React.Fragment>
            )
          }

          {
            this.props.paymentData.payment_method_id === Constants.PAYMENT_METHODS.MOVIL && (
              <React.Fragment>
                <p className="title">Pago Móvil</p>

                <div className="row px-3">
                  <div>
                    <p className="label-payment">Datos para el pago</p>
                    <p className="data-payment"><span>Banco: </span>{ payment_method?.bank?.name }</p>
                    <p className="data-payment"><span>Teléfono: </span>{ payment_method?.phonecode?.name }-{ payment_method?.phone }</p>
                    <p className="data-payment"><span>Documento: </span>{ payment_method?.document_type?.name }{ payment_method?.document }</p>
                  </div>

                  <div className="right">
                    <p className="label-payment">Monto a pagar</p>
                    <p className="label-amount">{ Globals.formatMiles(form.amount_bs, true, 'Bs.') }</p>
                    <p className="data-payment">Subtotal { Globals.formatMiles(form.subtotal * form.conversion, true, 'Bs.') }</p>
                    <p className="data-payment">IVA ({ form.iva_percentage }%): { Globals.formatMiles(form.iva * form.conversion, true, 'Bs.') }</p>
                  </div>
                </div>

                <p className="label-verify">Verificación de pago</p>
                <div className="row">
                  <div className="col-md-6">
                    <Select
                      className="select-bank"
                      placeholder="Banco"
                      name="bank_id"
                      value={ form.bank_id }
                      onChange={ this.change }
                      options={ this.state.banks } />
                  </div>
                  <div className="col-md-6">
                    <DatePicker
                      placeholder="Fecha del Pago"
                      maxDate={ moment().toDate() }
                      onChange={ (text: string) => this.change({ target: { value: text, name: 'payment_date' } }) }
                      value={ form.payment_date }
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      color="white"
                      value={ form.payment_phone }
                      name="payment_phone"
                      placeholder="Teléfono emisor"
                      onChange={ this.change } />
                  </div>
                  <div className="col-md-6">
                    <Input
                      color="white"
                      placeholder="Referencia"
                      name="reference"
                      value={ form.reference }
                      onChange={ this.change } />
                  </div>
                </div>
              </React.Fragment>
            )
          }

          <div className="text-center">
            <Button className="btn-next" onClick={ this.submit }>
              Guardar
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  }
})(AdPaymentModal);